import React from 'react';
import { Star, Quote } from 'lucide-react';
import { mockData } from '../mock';

const Testimonials = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Trusted by leading restaurants, hotels, and retailers across the region.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {mockData.testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-gradient-to-b from-white to-emerald-50/30 rounded-2xl p-8 shadow-lg border border-emerald-100 hover:shadow-xl transition-all group"
            >
              {/* Quote Icon */}
              <div className="w-12 h-12 bg-emerald-700 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <Quote className="text-white" size={24} />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, index) => (
                  <Star key={index} className="text-yellow-500 fill-yellow-500" size={20} />
                ))}
              </div>

              {/* Content */}
              <p className="text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="border-t border-emerald-100 pt-6">
                <div className="font-bold text-gray-900">{testimonial.name}</div>
                <div className="text-sm text-emerald-700 font-medium">{testimonial.role}</div>
                <div className="text-sm text-gray-600">{testimonial.company}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 bg-emerald-50 rounded-2xl p-8 border border-emerald-100">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900">Trusted By Leading Businesses</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center">
            {['5-Star Hotels', 'Restaurant Chains', 'Supermarkets', 'Bakeries'].map((type, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                  <Star className="text-emerald-700" size={32} />
                </div>
                <div className="font-semibold text-gray-900">{type}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
